import { Button } from "react-bootstrap";
import { Heading } from "../component/Heading";

import { Link, useNavigate, useParams } from "react-router";


export default function FailPage() {
    const navigate = useNavigate();
    const { company: companyParam } = useParams();
    return (
        <main>
            <div style={{ textAlign: "center", marginTop: 40 }}>
                <img src="/assets/fail.svg" alt="Fail" style={{ width: 120, height: 120, marginBottom: 24 }} />
                <h2 style={{ fontSize: 24, marginBottom: 16 }}>支付失敗</h2>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 20, marginTop: 16 }}>
                    <Button onClick={()=>{
                        navigate(`/${companyParam}/cart`, {replace: true});
                    }} style={{ display: "inline-block", marginTop: 24, padding: "12px 24px", backgroundColor: "var(--bs-primary)", color: "white", borderRadius: 50, textDecoration: "none"}}>
                        重新支付
                    </Button>
                    <Link to={`/${companyParam}`} style={{ textDecoration: "none"}}>
                        返回主頁
                    </Link>
                </div>
            </div>
        </main>
    );
}